import Funding from "../Funding";

describe("Funding model", () => {
  test("belongsTo relations", () => {
    expect(Funding.belongsTo.map(relation => relation.name)).toMatchSnapshot();
  });
});
